<mat-dialog-actions
  class="flex flex-[0_0_69px] gap-4 !justify-end !border-0 !border-t !border-solid !border-[#d5d7db] !m-[0_20px]"
>
  <a gnxAnchor (click)="cancel.emit()">{{ cancelLabel() || 'Cancel' }}</a>
  <span [matTooltip]="saveTooltip()" [matTooltipDisabled]="!saveTooltip()" matTooltipClass="blue-md-tooltip wider">
    <gnx-button type="blue" [padded]="true" size="h42" (click)="save.emit()" [disabled]="saveDisabled()">
      @if (saveLoading()) {
        <gnx-dots-loader />
      } @else {
        {{ saveLabel() || 'Save' }}
      }
    </gnx-button>
  </span>
</mat-dialog-actions>
